module.exports = __webpack_public_path__ + "img/sub_page_communication34.7579bd83.png";